module.exports = __webpack_public_path__ + "static/ffffffff-458e2dc522bdbb5f28b14617aece80c2.jpg";